export const CHECKOUT_URL = 'https://judo-coach-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/aGmAwNs2cnorWuc9v5HTSN/Diseno_sin_titulo_(65).png'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Judo Foundations & Athlete Development' },
  { kind: 'included', label: 'Volume 2 — Throwing Mechanics, Kuzushi & Technical Progressions' },
  { kind: 'included', label: 'Volume 3 — Throwing Systems, Combinations & Reactions' },
  { kind: 'included', label: 'Volume 4 — Newaza, Transitions & Groundwork Systems' },
  { kind: 'included', label: 'Volume 5 — Gripping, Tactics, Counters & Randori Development' },
  { kind: 'included', label: 'Volume 6 — 150 Ready-to-Coach Judo Sessions' },
  { kind: 'bonus', label: '100 Judo Coaching Cues & Error Corrections' },
  { kind: 'bonus', label: 'Judo Athlete Development Roadmap' },
  { kind: 'bonus', label: 'Judo Coaching Methods & Teaching Psychology' },
  { kind: 'bonus', label: 'Judo Safety, Ukemi & Injury Prevention Guide' },
  { kind: 'bonus', label: 'Judo Competition Preparation & Coach’s Match-Day Guide' },
  { kind: 'included', label: 'Immediate Digital Access' },
  { kind: 'included', label: 'PDF Format' },
  { kind: 'included', label: 'Highly Visual Coaching Material' },
]

export const finalIncludedItems: IncludedItem[] = [
  { kind: 'included', label: '6 Complete Volumes' },
  { kind: 'included', label: '150 Ready-to-Coach Judo Sessions' },
  { kind: 'included', label: 'Foundations & Athlete Development' },
  { kind: 'included', label: 'Throwing Mechanics & Kuzushi' },
  { kind: 'included', label: 'Combination & Reaction Systems' },
  { kind: 'included', label: 'Newaza & Groundwork Development' },
  { kind: 'included', label: 'Gripping, Tactics & Randori Development' },
  { kind: 'included', label: 'Visual Technique Breakdowns' },
  { kind: 'included', label: 'Coaching Corrections' },
  { kind: 'included', label: 'Ready-to-Use Session Structures' },
  { kind: 'included', label: 'Professional Coaching Tools' },
  { kind: 'bonus', label: '5 Professional Bonus Guides' },
  { kind: 'included', label: 'Immediate Digital Access' },
  { kind: 'included', label: 'PDF Format' },
]
